<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    {
        title: t('Ninguna'),
        value: 'Ninguna'
    },
    {
        title: t('Consignee'),
        value: 'Destinatario'
    },
    {
        title: t('Shipper'),
        value: 'Remitente'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="$t('Default Location')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
